import PropTypes from 'prop-types';
import { createElement } from 'react';

const Component = ({ as = 'div', children, ...props }) => {
  return createElement(as, props, children);
};

Component.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Component;
